import { http } from "../utils/http";

/** Планшет руководителя (правка №41). [Claude] 2026-11-03 */
export const getExecutiveOverview = ({ periodDays = 30, department = "", staleDays = 7 } = {}) => {
    const params = new URLSearchParams();
    params.set("period_days", String(periodDays));
    params.set("stale_days", String(staleDays));
    if (department) params.set("department", department);
    return http.get(`/executive/overview?${params.toString()}`);
};

export const getBoardPrefs = () => http.get("/ui-preferences/executive_board");
export const saveBoardPrefs = (prefs) => http.put("/ui-preferences/executive_board", prefs);
